// @flow
import React, { type Node } from 'react';
import { Grid, Row, Col } from 'clark-styles';
import SettingsDropdown from 'containers/settings-dropdown';
import {
  EngagementMsgLg,
  EngagementMsgSmall,
  HeaderBackground,
  ButtonContainer,
  Headline,
  Logo,
} from './styles';

const handleClick = () => {
  window.location = '/sessions/new';
};

type PropsType = {
  logoUrl: string,
  businessName: string,
  firstName: string,
  engagementDataEmpty: boolean,
};

const SessionsListHeader = ({
  logoUrl,
  businessName,
  firstName,
  engagementDataEmpty,
}: PropsType): Node => (
  <HeaderBackground>
    <Grid>
      <Row alignItems="flex-end">
        <Col sm={6} md={8} lg={8}>
          {logoUrl && <Logo src={logoUrl} alt={`${businessName} Logo`} />}
        </Col>
        <Col sm={6} md={4} lg={4}>
          <SettingsDropdown />
        </Col>
      </Row>
      <Row alignItems="center">
        <Col sm={12} md={8} lg={8}>
          <Headline>Welcome, {firstName}</Headline>
          {engagementDataEmpty && <EngagementMsgLg />}
        </Col>
        <Col sm={12} md={4} lg={4}>
          {engagementDataEmpty && <EngagementMsgSmall />}
          <ButtonContainer disabled={engagementDataEmpty} onClick={handleClick}>
            Create Session
          </ButtonContainer>
        </Col>
      </Row>
    </Grid>
  </HeaderBackground>
);

export default SessionsListHeader;



// WEBPACK FOOTER //
// ./src/components/sessions/list/header/index.js